// src/app/services/news.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface NewsItem {
  id: number;
  title: string;
  content: string;
  image: string;
  created_at: string;
  updated_at: string;
}

@Injectable({
  providedIn: 'root',
})
export class NewsService {
  private apiUrl = 'https://api.futuroacs.com.br/api/news';

  constructor(private http: HttpClient) {}

  getAll(): Observable<NewsItem[]> {
    return this.http.get<NewsItem[]>(this.apiUrl);
  }

  getById(id: number): Observable<NewsItem> {
    return this.http.get<NewsItem>(`${this.apiUrl}/${id}`);
  }
}
